import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import {
  getServicesPercentage,
  getProductsPercentage,
} from '../../../main/reports/payouts/helpers';

const payoutReport = state => state.reports.payoutsReports;
const makeReport = (report) => {
  if (isEmpty(report)) {
    return [];
  }

  return [{
    name: 'Services',
    total: report.totalCollectedServices,
    creditCardFees: report.serviceFees,
    netCollected: report.totalCollectedServices - report.serviceFees,
    percentage: getServicesPercentage(report),
    commission: report.servicesCommission,
    cashRetained: report.servicesCashRetained,
    commissionDue: report.servicesRevenue + report.servicesInstantPayoutFee,
    instantPayoutFee: report.servicesInstantPayoutFee,
    commissionDeposited: report.servicesRevenue,
  }, {
    name: 'Products',
    total: report.totalCollectedProducts,
    creditCardFees: report.productFees,
    netCollected: report.totalCollectedProducts - report.productFees,
    percentage: getProductsPercentage(report),
    commission: report.productsCommission,
    cashRetained: report.productsCashRetained,
    commissionDue: report.productsRevenue + report.productsInstantPayoutFee,
    instantPayoutFee: report.productsInstantPayoutFee,
    commissionDeposited: report.productsRevenue,
  }];
};

export const getBarberPayoutReport = createSelector(
  payoutReport,
  makeReport
);

const makeTipReport = (report) => {
  if (isEmpty(report)) {
    return [];
  }

  return [{
    name: 'Tips',
    ...report.tips,
  }];
};

export const getBarberPayoutTipReport = createSelector(
  payoutReport,
  makeTipReport,
);

export const makeSingleReportFromHistory = (reports) => {
  const report = reports[0];

  return {
    report: makeReport(report),
    tipReport: makeTipReport(report),
  };
};
